import { useQuery } from 'react-query';
import { fetcher } from '../utils/api';
import { ApiRoutes } from '../constants/routes';
import { useAuthProvider } from '../utils/auth';

// Hook to fetch act credit balance
export const useActCreditBalance = (actId, options = {}) => {
  const { user } = useAuthProvider();
  // Check if upload is in progress to disable polling
  const isUploading = typeof window !== 'undefined' && localStorage.getItem('isUploading') === 'true';
  
  return useQuery(
    ['actCreditBalance', actId],
    async () => {
      if (!actId) {
        throw new Error('Artist ID is required');
      }
      const response = await fetcher(`${ApiRoutes.ActCreditBalance}${actId}/credit-balance/`);
      return response.credit_balance || 0;
    },
    {
      refetchInterval: isUploading ? false : 30000, // Disable polling during upload
      staleTime: 10000, // Consider data stale after 10 seconds
      enabled: !!actId && !!user && !isUploading, // Only run if act ID is available, user is authenticated, and not uploading
      ...options
    }
  );
};

// Hook to fetch act details
export const useActDetails = (actId, options = {}) => {
  const { user } = useAuthProvider();
  
  return useQuery(
    ['actDetails', actId],
    async () => {
      if (!actId) {
        throw new Error('Artist ID is required');
      }
      return await fetcher(`${ApiRoutes.Act}${actId}/`);
    },
    {
      enabled: !!actId && !!user,
      ...options
    }
  );
};
